<template>
    <form-item-wrapper :widget="widget" :formData="formData" ref="itemref">
        <a-input v-model:value="formData[widget.name]" :disabled="widget.options.disabled"
            :placeholder="widget.options.placeholder" :allowClear="widget.options.allowClear"
            :maxlength="widget.options.maxLength" @change="handleOnChange" @pressEnter="handleOnPressEnter">
            <template v-if="widget.options.prefixIcon" #prefix>
                <component :is="widget.options.prefixIcon" />
            </template>
            <template v-if="widget.options.suffixIcon" #suffix>
                <component :is="widget.options.suffixIcon" />
            </template>
        </a-input>
    </form-item-wrapper>
</template>

<script setup>
import FormItemWrapper from "./form-item-wrapper.vue";
import { ref, toRefs } from 'vue';
import useEvent from "./useEvent";

const props = defineProps({
    widget: Object,
    formData: Object,
})
const { widget, formData } = toRefs(props)
const itemref = ref(null)

const {
    handleOnChange,
    handleOnPressEnter,
} = useEvent(widget.value, itemref, formData.value);
</script>